import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import DividerBottom from '../../ui/icons/dividers/bottom';
import DividerTop from '../../ui/icons/dividers/top';
import BPImage from '../../ui/v2/image';

import classes from './market.module.css';

const Market: FunctionComponent = () => {
  const { t } = useTranslation();

  const spanClass = 'py-2 w-1/2 lg:w-auto';
  return (
    <section>
      <DividerTop
        className={cx(
          'text-neutral-10',
          'w-full',
          'lg:h-16',
          'transform',
          'lg:scale-x-invert'
        )}
      />
      <div className={cx('bg-neutral-10')}>
        <div className={cx('flex', 'container', 'mx-auto', 'p-4')}>
          <div className="flex flex-wrap">
            <div className="order-1 lg:order-2 w-full lg:w-1/3 lg:text-right lg:pl-14 pb-4">
              <h2 className="text-right font-bold text-5xl lg:py-6 pb-3">
                {t('about:market.title')}
              </h2>
              <p className="text-justify">{t('about:market.text')}</p>
            </div>
            <div className="order-2 lg:order-1 w-full lg:w-2/3 pb-4">
              <BPImage
                src={`${process.env.PUBLIC_PREFIX}/img/about/market-map.png`}
                width={690}
                height={452}
                layout="responsive"
                alt={t('about:market.imgAlt')}
                quality={100}
              />
            </div>
            <div className="order-3 flex flex-wrap lg:flex-row w-full lg:justify-between">
              {[
                ['about:market.america', classes.green],
                ['about:market.oceania', classes.blue],
                ['about:market.europe', classes.lightBlue],
                ['about:market.africa', classes.orange],
                ['about:market.asia', classes.red],
              ].map(([key, colorClass]) => (
                <span
                  key={key}
                  className={cx(classes.circle, colorClass, spanClass)}
                >
                  {t(key)}
                </span>
              ))}
            </div>
          </div>
        </div>
        <DividerBottom
          className={cx(
            'text-white',
            'w-full',
            'lg:h-7',
            'transform',
            'scale-y-invert',
            'scale-x-invert'
          )}
        />
      </div>
    </section>
  );
};

export default Market;
